import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { RoleUpstream } from 'src/types/user';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

const fetchRolesData = async (endpoint: string): Promise<RoleUpstream[]> =>
  HttpService.get(endpoint, {})
    .then((data) => Promise.resolve(data.data))
    .catch((error) => Promise.reject(error.response.data));

const useRolesQuery = () => {
  const { currentSurvey } = useUserContext();
  const endpoint = generatePath(apiPaths.ROLE);

  return useQuery<RoleUpstream[]>({
    queryKey: [endpoint, currentSurvey?.id],
    queryFn: () => fetchRolesData(endpoint),
  });
};

export default useRolesQuery;
